import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import { history } from "@helpers/history";
import PlanAsistencia from './PlanAsistencia';
import PlanesAsistenciaListado from "./PlanesAsistenciaListado";
import { animations } from "react-animation";

function PlanesAsistenciaContainer(props) {
  const { match: { params } } = props;
  const [ viewDetail, setViewDetail ] = useState(0);
  const [matches, setMatches] = useState([])

  const {rutas} = useSelector(
    ({Base}) => Base.ContenidoCMS
  )

  const {planesAsistencia} = useSelector(
    ({AhorroYCredito}) => AhorroYCredito.AhorroYCredito
  )

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Planes de Asistencia Listado"
    );
  
    const prevRoute = defRoute.map(route => {
        return {
            url:route.url,
            text:route.title
        }
    })
      
    let promise = new Promise((resolve, reject) => {
      const idPlan=params?.id;
      let normalizePlans= planesAsistencia && planesAsistencia?.map(plan => ({...plan, nombre: (plan?.nombre).replace(/ /gi,"-").toLowerCase(), titulo:plan?.nombre, rutaPrevia:prevRoute}));      
      let resMatch = normalizePlans && normalizePlans?.filter(plan => plan.nombre === idPlan); 

      resolve(resMatch);
    });

    promise.then(resultado => {
      if(!isUndefined(resultado)){
        if(isUndefined(params.id)){
          setViewDetail(2)
        }else{
          if(!isEmpty(resultado)){
            setMatches(resultado)
            setViewDetail(1)
          }else{
            setViewDetail(3)
          }
        }
        
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[planesAsistencia]);

  useEffect(() => {
    viewDetail === 3 && history.push('/no-encontrado')
  },[viewDetail]);

  const renderResultView = () => {    
    return viewDetail === 1 ?
      (<PlanAsistencia dataPlan={matches} style={{ animation: animations.fadeIn }}/>)
    : viewDetail === 2 ?
      (<PlanesAsistenciaListado style={{ animation: animations.fadeIn }}/>)    
    : null
  }
    
  return (<>{renderResultView()}</>);
}

export default PlanesAsistenciaContainer;